// Utils
import { trainingConverter, energyConverter, sheddingConverter, sizeConverter } from '../../utils/converter'
// Styles
import styles from './Facts.module.scss'

const Facts = ({ breed }) => {
  const { name, description, lifeSpanMax, lifeSpanMin, weightMax, weightMin, temperament, easyToTrain, energyLevel, amountOfShedding, size } = breed

  const facts = [
    { img: '/facts/weight.svg', title: 'Weight', alt: 'Weight icon in pounds', value: `${weightMin} - ${weightMax} lbs` },
    { img: '/facts/type.svg', title: 'Size', alt: 'Dog icon', value: `${sizeConverter(size)}` },
    { img: '/facts/energy.svg', title: 'Energy', alt: 'Thunderbolt icon', value: `${energyConverter(energyLevel)}` },
    { img: '/facts/shedding.svg', title: 'Shedding', alt: 'Dog shedder icon', value: `${sheddingConverter(amountOfShedding)}` },
    { img: '/facts/training.svg', title: 'Trainability', alt: 'Badge icon', value: `${trainingConverter(easyToTrain)}` },
    { img: '/facts/life-span.svg', title: 'Life span', alt: 'Heart beat icon', value: `${lifeSpanMin} to ${lifeSpanMax} years` }
  ]

  const frenchDescription = (
    <p>
      French Bulldogs are small, reasonably independent and clever—all attributes that make them some of the <a href='https://www.mawoopets.com/blog/best-apartment-dogs'>best apartment dogs</a>. Frenchies are also affectionate with their families, and good with kids and other dogs. Easygoing and adaptable, these dogs are a good choice for owners without a lot of experience handling and training pets.
    </p>
  )

  return (
    <div className={styles.factsBackground}>
      <div className={styles.factsContainer}>
        <div className={styles.factsText}>
          <h2>{name} Breed Information</h2>
          {name === 'French Bulldog' ? <div>{frenchDescription}</div> : <p>{description}</p>}
          <p>
            {temperament
              ? (
                <>
                  <br />
                  <br />
                  <b>Temperament</b>
                  <br />
                  {temperament}
                </>)
              : null}

          </p>
        </div>
        <div className={styles.facts}>
          <div className={styles.factsHeader}>
            <p>Breed Fast Facts</p>
          </div>
          <div className={styles.info}>
            {facts.map((fact, i) => {
              return (
                <div key={i} className={styles.fact}>
                  <img src={fact.img} alt={fact.alt} width={20} height={20} />
                  <h5>{fact.title}</h5>
                  <p>{fact.value}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>

  )
}

export default Facts
